export const setBrowseConfigData = (id: string, pageNum: number, filterValues: any) => ({
    type: 'SET_BROWSE_CONFIG_DATA',
    id,
    pageNum,
    filterValues,
});
